<template>
    <element-badge :color="statusColor" uppercase>{{ budget.status }}</element-badge>
</template>

<script>
import Budget from '@/Models/Budget';

export default {
    props: {
        budget: {
            type: Budget,
            required: true,
        },
    },

    computed: {
        statusColor() {
            switch (this.budget.status) {
                case BudgetStatus.LOCKED:
                    return 'red';
                case BudgetStatus.IN_REVIEW:
                    return 'yellow';
                case BudgetStatus.DRAFT:
                default:
                    return 'green';
            }
        },
    },
};
</script>
